import type {
  ISettingsSystem,
  ITimesheetCategories,
} from 'interfaces/SystemSettings.interface';
import type { TCurrencyName } from 'services/currency/currency.types';
import { useGetSystemSettingsQuery } from 'services/teamHeroApi.service';

interface IUseGetSystemSettingsReturn {
  systemSettings?: ISettingsSystem;
  preferredFields: string[];
  currency: TCurrencyName;
  docuSignClientId?: string;
  supportUrl: string;
  apiVersion?: string;
  configrepoVersion?: string;
  checkinRange: number;
  timetrackingMaxHours: number;
  jobNotifications: {
    notifyOn: number[];
    notifyAt?: number;
    daysCount?: number;
  };
  isLoading: boolean;
  signatureProvider?: string;
  timetrackingRounding?: number;
  timesheetCategories?: ITimesheetCategories;
  referring_person_bonus: number | null;
  referred_person_bonus: number | null;
  timeTrackingCategoriesEnabled?: boolean;
}

export const useGetSystemSettings = (
  skip = false
): IUseGetSystemSettingsReturn => {
  const { data: settingsData, isLoading } = useGetSystemSettingsQuery(
    undefined,
    { skip }
  );

  const preferredFields = settingsData?.settings.preferred_fields || [];
  const currency = settingsData?.settings.currency || 'EUR';
  const supportUrl = settingsData?.settings.support_url?.hero || '';
  const apiVersion = settingsData?.settings.api_version;
  const configrepoVersion = settingsData?.settings.configrepo_version;
  const checkinRange = settingsData?.settings.shift_checkin_range || 0;
  const docuSignClientId = settingsData?.settings?.docu_sign_client_id;
  const timetrackingRounding = settingsData?.settings.timetracking_rounding;
  const jobsNotifications = settingsData?.settings.jobs_notifications;
  const timetrackingMaxHours =
    settingsData?.settings.time_tracking_max_hours || Number.MAX_SAFE_INTEGER;
  const timesheetCategories = settingsData?.settings.timesheet_categories;

  const jobNotifications = {
    notifyOn: jobsNotifications?.notify_on || [],
    notifyAt: jobsNotifications?.notify_at,
    daysCount: jobsNotifications?.upcoming_days_count,
  };

  const referring_person_bonus =
    settingsData?.settings.referring_person_bonus || null;
  const referred_person_bonus =
    settingsData?.settings.referred_person_bonus || null;

  const timeTrackingCategoriesEnabled =
    settingsData?.settings.time_tracking_categories_enabled;

  return {
    systemSettings: settingsData?.settings,
    preferredFields,
    currency,
    docuSignClientId,
    supportUrl,
    apiVersion,
    configrepoVersion,
    checkinRange,
    isLoading,
    jobNotifications,
    signatureProvider: settingsData?.settings?.signature_provider,
    timetrackingMaxHours,
    timetrackingRounding,
    timesheetCategories,
    referring_person_bonus,
    referred_person_bonus,
    timeTrackingCategoriesEnabled,
  };
};
